module.exports = __webpack_public_path__ + "img/begin-master.6608a289.png";